import React from 'react'
import styled from '@emotion/styled'

import Select from '@peracto/peracto-editor-ui/dist/Select'

const SelectWrapper = styled.div`
    width: 50%;
`

const Size = ({ value, ...props }) => {
    if (value) {
        value = value.value
    }

    return (
        <SelectWrapper>
            <Select value={value} {...props} />
        </SelectWrapper>
    )
}

export default Size
